var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactCheck24Dp5F6368Fill0Wght200Grad0Opsz24 = function SvgFactCheck24Dp5F6368Fill0Wght200Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    fill: "#5f6368"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220-300h160v-40H220v40Zm362-88.46L751.54-558 723-586.54l-141 142-57-57L497.46-473 582-388.46ZM220-460h160v-40H220v40Zm0-160h160v-40H220v40ZM120-160v-640h720v640H120Zm40-40h640v-560H160v560Zm0 0v-560 560Z"
  })));
};
export default SvgFactCheck24Dp5F6368Fill0Wght200Grad0Opsz24;